import { SessionModel } from './entities/sessionModel';
import { UserModel } from '../shared/model/userModel';
import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { QuestionModel } from './entities/QuestionModel';


export abstract class AbstractSessionService {
  abstract login(user: UserModel): Observable<boolean>;
  abstract getSession(): Promise<SessionModel>;
  abstract logout(): void;
  abstract getQuestion(username: string): Observable<QuestionModel>;
  abstract getVersion(): Observable<string>;
  abstract activateIdle(): void;
}



// WEBPACK FOOTER //
// ./src/app/session/abstract-session.service.ts